import React from 'react';
import { connect } from 'react-redux';

import { interpolate } from '@/utils';
import { CmsPageContentIdentifier, CmsPageContentType, ReduxStateType } from '@/types/av-check';

export interface StateProps {
  cmsContent: CmsPageContentType,
}

export interface AlertBoxProps {
  type: string,
  contentIdentifier: CmsPageContentIdentifier,
  contentParams?: any,
  titleIdentifier?: CmsPageContentIdentifier,
  titleParams?: any,
}

const AlertBox = ({
  cmsContent,
  type,
  contentIdentifier,
  contentParams = {},
  titleIdentifier,
  titleParams = {},
}: StateProps & AlertBoxProps) => {
  const content = cmsContent[contentIdentifier];
  const title = titleIdentifier && cmsContent[titleIdentifier];

  const finalContent = content != null ? interpolate(content, contentParams) : '';
  const finalTitle = title && interpolate(title, titleParams);

  return (
    <div
      className={`alert alert-${type}`}
      role="alert"
    >
      { finalTitle && <h3 dangerouslySetInnerHTML={{ __html: finalTitle }} /> }
      <p dangerouslySetInnerHTML={{ __html: finalContent }} />
    </div>
  );
};

const mapStateToProps = (state: ReduxStateType) => ({
  cmsContent: state.cmsContent,
});

export default connect(mapStateToProps)(AlertBox);
